// import React from "react";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Form from "./Screens/Form";
import DisplayForm from "./Screens/DisplayForm";
import { authReducer } from "./State/Reducer/auth";
import { combineReducers, createStore } from "redux";
import { Provider, useSelector, useDispatch } from "react-redux";
import { AutoLogin, LogoutAction, STORAGE_KEY } from "./State/Action/auth";
import { AdminRoute } from "./Route/AdminRoute";
import { PageNotFoundScreen } from "./Screens/PageNotFoundScreen";
import { LoginScreen } from "./Screens/LoginScreen";
import { api_interceptor } from "./State/Interceptor/interceptor";
import CropImage from "./Screens/CropImage"

const rootReducer = combineReducers({
  auth: authReducer,
});

const store = createStore(rootReducer);

function App() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setloading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    setloading(true);
    let previous_login = localStorage.getItem(STORAGE_KEY);
    if (previous_login) {
      const { token, type } = JSON.parse(previous_login);
      dispatch(AutoLogin({ token: token, type: type }));
    }
    setloading(false);
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (token) {
      api_interceptor.defaults.headers.common["authorization"] = token;
    }
    api_interceptor.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.response.status === 511) {
          alert("Session expired");
          dispatch(LogoutAction());
        }
        return Promise.reject(err);
      }
    );
    return () => {};
  }, [token, dispatch]);

  return (
    <div className="h-full min-h-screen">
      <Router basename="/JCI">
        {loading ? (
          <Routes>
            <Route element={<p>Loading...</p>} path="*" />
          </Routes>
        ) : (
          <Routes>
            <Route element={<Form />} path="/" />
            <Route element={<DisplayForm />} path="/directory" />
            <Route
              element={<AdminRoute type="user" Component={LoginScreen} />}
              path="/user"
            />
            <Route
              element={<AdminRoute type="profile" Component={Form} />}
              path="/profile"
            />
            <Route element={<PageNotFoundScreen />} path="/*" />
            
            <Route element={<CropImage />} path="/cropimage" />
          </Routes>
        )}
      </Router>
    </div>
  );
}

export default function RootApp() {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}
